import { render } from "./LoginPayrecon.vue?vue&type=template&id=ace9aa40"
import script from "./LoginPayrecon.vue?vue&type=script&lang=js"
export * from "./LoginPayrecon.vue?vue&type=script&lang=js"
script.render = render

export default script